import React, { useEffect } from 'react';
import { dispatch } from '../../store';
import { handleTeacherProfileRequest } from '../../modules/teachers/redux';
import { MainLayout, SecondaryLayout, StyledContent } from '../../styles/StyledComponents';
import SiderNav from '../template/SiderNav';

export const TeacherLayout = ({ children, user, teacher }) => {
  useEffect(() => {
    if (!teacher || Object.keys(teacher).length === 0) {
      dispatch(handleTeacherProfileRequest(user.id));
    }
  }, []);

  return (
    <MainLayout hasSider>
      <SiderNav />
      <SecondaryLayout>
        <StyledContent>{children}</StyledContent>
      </SecondaryLayout>
    </MainLayout>
  );
};
